module.exports = __webpack_public_path__ + "img/boost.7ccdeced.jpg";